import { FC, ReactNode } from 'react'
import { useUA } from 'context'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'
import { ButtonProps } from '@app.components/Button/Button'

interface IFProps extends ButtonProps {
  children: ReactNode
  type?: 'button' | 'submit' | 'reset'
  hasIcon?: boolean
}

const GradientExamButton: FC<IFProps> = ({
  children,
  type = 'button',
  hasIcon = true,
  ...props
}) => {
  const { isMobile } = useUA()

  return (
    <StyledWrapper isMobile={!!isMobile} type={type} {...props}>
      {children}
      {hasIcon && <ArrowRight className="arrow-icon" />}
    </StyledWrapper>
  )
}

export default GradientExamButton

type TStyleWrapper = {
  isMobile: boolean
}

const desktopStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 460px;
  height: 80px;
  padding: 23px 57px 22px;
  font-size: 24px;

  .arrow-icon {
    width: 18px;
    height: 18px;
    margin-left: 4px;
  }
`

const mobileStyles = css`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 44px;
  font-size: 16px;

  .arrow-icon {
    margin-left: 4px;
    width: 14px;
    height: 14px;
  }
`

const StyledWrapper = styled.button<TStyleWrapper>`
  border: none;
  border-radius: 8px;
  line-height: 43px;
  letter-spacing: -0.96px;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;

  background: linear-gradient(to bottom, #01a0ff, #004eff);

  &:hover {
    background: linear-gradient(to bottom, #19a9ff, #1a66ff);
  }

  ${({ isMobile }) => (isMobile ? mobileStyles : desktopStyles)}
`
